export default __webpack_public_path__ + "static/media/social_media_new_twitter.ec400485.svg";